import React from 'react';
export function Footer() {
  return <footer className="w-full bg-charcoal py-9" data-id="element-64" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-6xl px-6 text-center" data-id="element-65" data-mp="3gezdp53xpt1o">
        <p className="font-display text-lg tracking-[0.14em] text-cream" data-id="element-66" data-mp="3ggk90wy2pg0l">
          BALLET TEACHER <span className="text-rose" data-id="element-67" data-mp="32pfg0dp7nlz8">ELITE SYSTEM</span>
        </p>
        <div className="mx-auto mt-5 h-px w-16 bg-gold/50" aria-hidden="true" data-id="element-68" data-mp="36ooa5jo5xlvb" />
        <p className="mt-5 font-sans text-xs leading-relaxed text-cream/60" data-id="element-69" data-mp="3ufa6idot1hph">
          © 2026 Ballet Teacher Elite System — All rights reserved.
        </p>
        <p className="mt-1 font-sans text-xs leading-relaxed text-cream/60" data-id="element-70" data-mp="37xwcimca4j2">
          Designed for ballet educators teaching ages 3–16 worldwide.
        </p>
      </div>
    </footer>;
}